import { ReactElement } from 'react';
import { styled } from '@mui/material';
import { IDeaRegistration, ValueLabel, variables } from '../common';
import { show } from '.';
import { map as lmap, compose as lcompose } from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';

export const renderStack = (properties: ValueLabel<keyof IDeaRegistration>[]) =>
  lcompose(
    fold(
      () => <article>Empty</article>,

      deaRegistrations => (
        <Articl>
          {lmap<IDeaRegistration, ReactElement>(a => (
            <Article key={a.deaNum}>
              {lmap<ValueLabel<keyof IDeaRegistration>, ReactElement>(
                ({ value, label }) => (
                  <Line key={value}>
                    <Label>{label}:</Label>
                    <span>{show(value)(a)}</span>
                  </Line>
                )
              )(properties)}
            </Article>
          ))(deaRegistrations)}
        </Articl>
      )
    ),
    (deaRegistrations: IDeaRegistration[]) =>
      deaRegistrations.length === 0
        ? left(deaRegistrations)
        : right(deaRegistrations)
  );

const Articl = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },
}));

const Article = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },

  paddingBottom: '0.5rem',
  borderBottom: variables.cardBorder,
}));

const Label = styled('span')(({ theme }) => ({ fontWeight: 700 }));

const Line = styled('span')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '1rem',
  },
}));
